
import { computed, defineComponent, ref } from "vue";
import { useStore } from "vuex";
import router from "@/router";
import CourseCard from "@/components/course/CourseCard.vue";
import CourseFilterModal from "@/components/modals/CourseFilterModal.vue";
import { Actions, Mutations } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "course-catalog",
  components: {
    CourseCard,
    CourseFilterModal
  },
  setup() {
    const store = useStore();
    const user = computed(() => store.getters.currentUser);
    store.dispatch("getAllCourses");
    const courses = computed(() => store.getters.getCourseData);
    const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));
    
    const isFilterModalOpen = ref(false);

    // Separar cursos com e sem certificado
    const coursesWithCertificate = computed(() => {
      return courses.value?.data?.filter(course => course.has_certificate === true) || [];
    });

    const coursesWithoutCertificate = computed(() => {
      return courses.value?.data?.filter(course => course.has_certificate !== true) || [];
    });
    
    // Obter filtros ativos do store
    const activeFilters = computed(() => store.getters.getCourseFilters);
    
    // Verificar se há filtros ativos
    const hasActiveFilters = computed(() => {
      const filters = activeFilters.value;
      return !!(filters.name || (filters.types && filters.types.length > 0));
    });
    
    const openFilterModal = () => {
      isFilterModalOpen.value = true;
    };
    
    const closeFilterModal = () => {
      isFilterModalOpen.value = false;
    };
    
    const clearFilters = async () => {
      // Limpar filtros do store
      await store.commit(Mutations.SET_COURSE_FILTERS, { name: null, types: [] });
      
      // Recarregar todos os cursos
      await store.dispatch(Actions.GET_ALL_COURSES);
    };
    
    const applyFilter = async (filters: any) => {
      // Construir o payload
      const filterPayload = {
        filters: {
          name: filters.name || null,
          types: filters.types && filters.types.length > 0 ? filters.types : []
        }
      };
      
      // Salvar os filtros no store PRIMEIRO via commit
      store.commit(Mutations.SET_COURSE_FILTERS, {
        name: filterPayload.filters.name,
        types: filterPayload.filters.types
      });
      
      // Agora buscar os cursos filtrados
      try {
        // Construir query params para a API
        const params = new URLSearchParams();
        
        if (filterPayload.filters.name) {
          params.append('filters[name]', filterPayload.filters.name);
        }
        
        if (filterPayload.filters.types && filterPayload.filters.types.length > 0) {
          filterPayload.filters.types.forEach((type: string) => {
            params.append('filters[types][]', type);
          });
        }
        
        const queryString = params.toString();
        const url = queryString ? `/academy/courses/list?${queryString}` : '/academy/courses/list';
        
        // Chamar a API diretamente via ApiService
        const ApiService = (await import('@/core/services/ApiService')).default;
        const response = await ApiService.get(url);
        
        // Salvar os dados dos cursos
        store.commit(Mutations.SET_COURSE_DATA, response.data);
      } catch (error) {
        store.commit(Mutations.SET_COURSE_DATA, {});
      }
      
      // Fechar o modal
      closeFilterModal();
    };

    return {
      user,
      courses,
      coursesWithCertificate,
      coursesWithoutCertificate,
      router,
      currentLanguage,
      isFilterModalOpen,
      activeFilters,
      hasActiveFilters,
      openFilterModal,
      closeFilterModal,
      clearFilters,
      applyFilter
    };
  },
  methods: {
    openCourse(id) {
      this.$router.push({
        name: "training-course",
        params: {
          course_id: id
        }
      });
    }
  }
});
